import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Collapse } from 'reactstrap';
import { css } from '@emotion/react';
import { Link } from 'gatsby';
import FrontpageLink from './FrontpageLink';
import LanguageDropdown from './LanguageDropdown';
import { buildUtmUrl } from '@lib/searchQuery';

const LanguageCss = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-bottom: 1rem;
`;

const LinkCss = css`
  transition: 0.5s;
  color: #ffffff;
  margin-left: 2rem;
  &:hover {
    text-decoration: none;
    color: #ffffffaa;
  }
`;

const DarkLinkCss = css`
  color: #282c2f;
  margin-left: 2rem;
  &:hover {
    text-decoration: none;
    color: #282c2faa;
  }
`;

export const ButtonCss = css`
  display: inline-block;
  transition: 0.5s;
  color: #ffffff;
  background-color: var(--primary);
  padding: 0.2rem 1rem;
  border-radius: 1.25rem;
  text-transform: uppercase;
  font-weight: 600;
  margin-left: 2rem;
  &:hover {
    text-decoration: none;
    background-color: #8dc63faa;
    color: #ffffff;
  }
`;

export const DarkButtonCss = css`
  display: inline-block;
  transition: 0.5s;
  color: #ffffff;
  background-color: #282c2f;
  padding: 0.2rem 1rem;
  border-radius: 1.25rem;
  text-transform: uppercase;
  font-weight: 600;
  margin-left: 2rem;
  &:hover {
    text-decoration: none;
    background-color: #282c2faa;
    color: #ffffff;
  }
`;

// eslint-disable-next-line complexity
export default function Header({ /*slug, */dark, language, refs, layouts }) {

  const { header } = layouts.find(layout => layout.header);

  const [open, setOpen] = useState(false);
  const MenuRef = useRef(null);

  function close(e) {
    if (MenuRef.current && !MenuRef.current.contains(e.target)) {
      setOpen(false);
    }
  }

  useEffect(() => {
    document.addEventListener('click', close);
    return () => {
      document.removeEventListener('click', close);
    };
  }, [open]);

  return (
    <div className="container py-3">
      <div css={LanguageCss}>
        <LanguageDropdown dark={dark} language={language} refs={refs} />
      </div>
      <div>
        <div className="d-flex justify-content-between align-items-center">
          <Link to={(language.path || '') + '/'} id="logo">
            <img
              css={css`
                height: 32px;
              `}
              src={
                dark ? header.alt_logo.localFile.publicURL : header.logo.localFile.publicURL
              }
              alt="logo"
            />
          </Link>
          <div className="links  d-none d-md-block ">
            {header.links &&
              // eslint-disable-next-line complexity
              header.links.map(({ link }, i) => (
                <Fragment key={`link-header-${i}`}>
                  <FrontpageLink
                    url={link.style === 'link' ? link.url : buildUtmUrl(link.url, 'header', 'cta_button_header')}
                    text={link.text}
                    css={dark ? link.style === 'link' ? DarkLinkCss : DarkButtonCss
                      : link.style === 'link' ? LinkCss : ButtonCss}
                  />
                </Fragment>
              ))
            }
          </div>
          <div className="d-block d-md-none">
            <svg
              onClick={(/*e*/) => setOpen(o => !o)}
              viewBox="0 0 24 24"
              width="32"
              height="32"
              style={{ fill: 'var(--primary)' }}
            >
              <path d="M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z" />
            </svg>
          </div>
        </div>
        <Collapse isOpen={open}>
          {' '}
          <div
            ref={MenuRef}
            className="d-flex flex-column align-items-end"
            css={css`
              > * {
                margin-top: 1.25rem;
              }
            `}
          >
            {' '}
            {header.links &&
              header.links.map(({ link }, i) =>
                link.style === 'link' ? (
                  <FrontpageLink
                    key={`header-link-${i}`}
                    css={dark ? DarkLinkCss : LinkCss}
                    url={link.url}
                    text={link.text}
                  />
                ) : (
                  <div key={link.url}>
                    <FrontpageLink
                      key={`header-link-${i}`}
                      css={[
                        dark ? DarkButtonCss : ButtonCss,
                        css`
                          margin-right: -3px;
                        `
                      ]}
                      url={buildUtmUrl(link.url, 'header', 'cta_button_header')}
                      text={link.text}
                    />
                  </div>
                )
              )}
          </div>
        </Collapse>
      </div>
    </div>
  );
}